import * as ExifReader from 'exifreader';

export default async function getImageMetadata(file: File): Promise<ExifReader.ExpandedTags> {
  const fileBuffer = await file.arrayBuffer()
  const tags = ExifReader.load(fileBuffer, { expanded: true });
  return tags
}